<style>
.v-toolbar__content{
      padding: 0 16px !important;
}
</style>
<template >
  <v-app id="inspire" style="padding: 0 16px;background: rgb(242, 245, 248);">
    
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      fixed
      temporary
      v-if="logueado && esSubusuario == false"
    >
      <v-list dense>
        <template  v-if="esAdministrador || esOpcomercial ||esCliente || esOperaciones ||  esComercial || esComercialAgente || esPricingT || esPricing || esPricingAgente || esFinanzas || esComercialAdmin || esMarketing || esVentasFree">
          <v-list-item :to="{name:'Tracking'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>share_location</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Tracking<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador || esCliente ">
          <v-list-item :to="{name:'AddUsers'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>person_add</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Add Users<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador">
          <v-list-item :to="{name:'about'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>bar_chart</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Inicio<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador || esFinanzas || esMarketing" >
          <v-list-item :to="{name:'dashboard'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>space_dashboard</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Dashboard<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador" >
          <v-list-item :to="{name:'pruebamsc'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>event</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              pruebamsc<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador" >
          <v-list-item :to="{name:'Actividadesprueba'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>event</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Actividades pruebas<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador|| esOpcomercial || esTelemarketing || esComercial || esComercialAgente || esPricingT || esPricing || esPricingAgente || esFinanzas || esComercialAdmin || esMarketing || esVentasFree" >
          <v-list-item :to="{name:'calendario'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>event</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Actividades<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador" >
          <v-list-item :to="{name:'notificaciones'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>forward_to_inbox</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Notificaciones<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador || esComercialAdmin || esMarketing || esComercial || esPricingAgente" >
          <v-list-item :to="{name:'target'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>paid</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Target<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador || esOpcomercial ||esComercialAdmin || esMarketing ||  esComercial || esPricingAgente || esFinanzas" >
          <v-list-item :to="{name:'reportbs'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>query_stats</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Report BS<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador || esComercialAdmin || esMarketing || esFinanzas " >
          <v-list-item :to="{name:'Calendarioejecutivos'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>calendar_month</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Actividades Ejecutivos<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template  v-if="esAdministrador || esOpcomercial ||esTelemarketing || esComercial || esComercialAgente || esPricingT || esPricing || esPricingAgente || esFinanzas || esComercialAdmin || esVentasFree || esMarketing" >
          <v-list-item :to="{name:'prospectos'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>person_search </v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Prospectos<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-if="esAdministrador || esPricingT || esPricing || esPricingAgente || esMarketing || esComercialAdmin">
          <v-list-item :to="{name:'home'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>signal_cellular_alt</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
              Reporte Actividades<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-if="esAdministrador||esOpcomercial || esComercial || esComercialAgente || esPricingT || esPricing || esPricingAgente || esComercialAdmin || esMarketing ||  esTelemarketing">
          <v-list-item :to="{name:'Bs'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>business</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
               Buying and Selling<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-if="esAdministrador||esOpcomercial || esOperaciones">
          <v-list-item :to="{name:'vessels'}"><!--Indicamos a que ruta vamos a acceder al hacer click-->
            <v-list-item-action>
              <v-icon>directions_boat</v-icon><!--Mostramos icono home en el menu-->
            </v-list-item-action>
            <v-list-item-title>
               Vessels<!--Mostramos el titulo de Inicio-->
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-if="esAdministrador|| esOpcomercial || esOperaciones || esFinanzas"><!--Operaciones-->
          <v-list-group >
            <v-list-item slot="activator" ><!--Se agrega un gupo de opciones y se indica que es el activador para desplegarlas-->
              <v-list-item-content>
                <v-list-item-title>
                  Operaciones
                </v-list-item-title>
              </v-list-item-content>              
            </v-list-item>
            <v-list-item :to="{name:'Bs'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>business</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Buying and Selling
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'oscar'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>anchor</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Shipment
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'bl'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>post_add</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  BL
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>  
            <v-list-item :to="{name:'inland'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>local_shipping</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Inland
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item> 
            </v-list-group >
        </template>
        <template v-if="esAdministrador || esMarketing || esFinanzas"><!--Catalogos-->
          <v-list-group>
            <v-list-item slot="activator"><!--Se agrega un gupo de opciones y se indica que es el activador para desplegarlas-->
              <v-list-item-content>
                <v-list-item-title>
                  Catalogos
                </v-list-item-title>
              </v-list-item-content>              
            </v-list-item>
            <v-list-item :to="{name:'country'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>emoji_flags</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Países
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'prospectos'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>person_search</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Prospectos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'industria'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>construction</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Industria
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'charges'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>playlist_add</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Cargos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'port'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>pin_drop</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Puertos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>  
            <v-list-item :to="{name:'usuarios'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>person_add_alt_1</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Usuarios
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item> 
            <v-list-item :to="{name:'container'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Contenedores
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
             <v-list-item :to="{name:'datos'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Provider / Agent /Client
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item> 
            <v-list-item :to="{name:'relacion'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Relacion Cliente-Proveedor
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>          
          </v-list-group>
        </template>
        <template v-if="esAdministrador|| esOpcomercial ||esTelemarketing || esPricingT || esPricing || esPricingAgente || esComercial || esComercialAgente || esFinanzas || esComercialAdmin || esVentasFree || esMarketing"><!--Comercial-->
          <v-list-group>
            <v-list-item slot="activator"><!--Se agrega un gupo de opciones y se indica que es el activador para desplegarlas-->
              <v-list-item-content>
                <v-list-item-title>
                  Comercial
                </v-list-item-title>
              </v-list-item-content>              
            </v-list-item>
            <v-list-item :to="{name:'cotizacion'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>library_books</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Cotizaciones
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'scotizacion'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>list_alt</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Solicitud de Tarifa
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'ReporteEjecutivos'}"  v-if="esAdministrador || esComercialAdmin || esFinanzas"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>list_alt</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Reporte de Ejecutivos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>          
          </v-list-group>
        </template>        
        <template v-if="esAdministrador || esPricingT || esPricing || esPricingAgente || esOperacionesPricing"><!--Pricing-->
          <v-list-group>
            <v-list-item slot="activator"><!--Se agrega un gupo de opciones y se indica que es el activador para desplegarlas-->
              <v-list-item-content>
                <v-list-item-title>
                  Pricing
                </v-list-item-title>
              </v-list-item-content>              
            </v-list-item>
            <v-list-item :to="{name:'tarifa'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>receipt_long</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Recepción Tarifas
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'tariffs'}"  v-if="esAdministrador"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>note_add</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Tarifarios
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>            
          </v-list-group>
        </template>
        <template v-if="esMarketing"><!--Marketing-->
          <v-list-group>
            <v-list-item slot="activator"><!--Se agrega un gupo de opciones y se indica que es el activador para desplegarlas-->
              <v-list-item-content>
                <v-list-item-title>
                  Marketing
                </v-list-item-title>
              </v-list-item-content>              
            </v-list-item>
            <v-list-item :to="{name:'campañas'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Campañas
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'cotizacion2'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Cotizacion
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>            
          </v-list-group>
        </template>
        <template v-if="esAdministrador || esFinanzas"><!--Comercial-->
          <v-list-group>
            <v-list-item slot="activator"><!--Se agrega un gupo de opciones y se indica que es el activador para desplegarlas-->
              <v-list-item-content>
                <v-list-item-title>
                  Finanzas
                </v-list-item-title>
              </v-list-item-content>              
            </v-list-item>
            <v-list-item :to="{name:'moneda'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Moneda
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'tipocambio'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Tipo de cambio
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name:'facturas'}"><!--hacemos referencia a una ruta-->
              <v-list-item-action>
                <v-icon>description</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                 Charges references
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item> 
            <!--<v-list-item :to="{name:'TerminosFactura'}"><
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Terminos Factura
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>     -->
          </v-list-group>
        </template>  
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      blue
      app
      :clipped-left="$vuetify.breakpoint.mdAndUp"            
      fixed
      v-if="logueado"      
    >
      <v-app-bar-nav-icon style="color: #1d4980;" @click.stop="drawer = !drawer" />
      <v-spacer></v-spacer>
       <v-tooltip bottom v-if="ntarget != 0">
          <template v-slot:activator="{ on, attrs }">
            <v-progress-linear
                v-bind="attrs"
                v-on="on"
                :color="ncolor"
                style="height:100%;width: 200px;"
                :value="PromedioVenta()"
              >
                <span  v-if="ntarget == 0"></span>
                <span v-else>{{parseFloat(PromedioVenta()).toFixed(2)}}%</span>
            </v-progress-linear>
          </template>
          <span >${{addCommas(parseFloat(totalprofit).toFixed(2))}} de ${{addCommas(parseFloat(ntarget).toFixed(2))}}</span>
        </v-tooltip>
      <v-menu offset-y
      transition="slidey-transition"
      bottom
      >
        <template v-slot:activator="{ on, attrs }" v-if="logueado">          
          <v-btn           
          v-bind="attrs"
          v-on="on"
          elevation="0" text class="ma-2" style="height: 100%;">
            <v-row>
              <v-col style="padding: 0;">
                <v-icon style="font-size: 1.85rem;color: #1d4980;">person</v-icon>
              </v-col>
              <v-col style="padding: 0;display: flex;align-items: center;">
                <span style="font-size: 0.7rem;color: #1d4980;">{{name()}}</span><span class="material-icons" style="color: #1d4980;">expand_more</span>
              </v-col>
            </v-row>              
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="salir">
            <v-list-item-title style="color: red;font-size: .8rem;">              
                <v-icon style="color: red;font-size: 1rem;">logout</v-icon>
                LOGOUT              
            </v-list-item-title>            
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container
        class="fill-height"
        fluid
        style="background:#f2f5f8;overflow: auto;"
      >
       <v-slide-y-transition mode="out-in">
            <ModalIdle v-if="isIdle" />
             
         <router-view/>
       </v-slide-y-transition>
      </v-container>
    </v-main>
    <v-footer  height="auto" >
      <v-layout justify-center>
        <v-flex text-xs-center>
          <v-card flat tile class="blue-text" style="background: rgb(242, 245, 248);">
            <v-card-text class="blue--text pt-0">
              Optima Global Logistics, S.A. de C.V. &copy;2020
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template> 
<script>
import axios from 'axios'
import ModalIdle from '@/components/ModalIdle.vue'

export default {
  name: 'App',
  data() {
    return{
      ncolor:'',
      sintarget:'not target',
      porsentajecumplido:0,
      knowledge: 33,
      clipped:false,
      drawer:true,
      fixed:false,
      items:[{
        icon:'bubble_chart',
        title:'Inspire'
      }],
      miniVariant:false,
      right:true,
      rightDrawer:false,
      title:'Vuetify.js',
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' },
      ],
      Nusers:'',
      ncontainer: '',
      ntamaño: '',
      tarifasListar: [],
      infcontainers: [],
      totalsell: 0,
      totalbuy: 0,
      totalselliva:0,
      totalbuyiva:0,
      totalprofitiva: 0,
      totalbuybs: 0,
      totalsellbs: 0,
      tprofitbs:0,
      tprofit:0,
      totalprofit:0,
      BuySellLista:[],
      targets:[],
      ntarget:0,
      finicio:null,
      ffin:null,
    }
  },
  components: {
    ModalIdle,
  },
  computed:{
    isIdle(){
      if(this.$store.state.idleVue.isIdle == true && this.$store.state.usuario != null){
        window.alert('Session Expired');
        this.$store.dispatch("salir");
      }
    },
    logueado(){
      return this.$store.state.usuario;
    },
    esAdministrador(){
      this.reporteventas();
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Administrador';
    },
    esComercial(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Comercial';
    },
    esComercialAgente(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'ComercialAgente';
    },
    esMarketing(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Marketing';
    },
    esPricingT(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'PricingTerrestre';
    },
    esPricing(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Pricing';
    },
    esPricingAgente(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'PricingAgente';
    },
    esOperacionesPricing(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Operaciones' && this.$store.state.usuario.iddecrol == 2;
    },
    esOperaciones(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Operaciones';
    },
    esFinanzas(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Finanzas';
    },
    esComercialAdmin(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'ComercialAdmin';
    },
    esVentasFree(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'VentasFree';
    },
    esCliente(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Cliente';
    },
    esSubusuario(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Subusuario';
    },
    esTelemarketing(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'Telemarketing';
    },
    esOpcomercial(){
      return this.$store.state.usuario && this.$store.state.usuario.rol == 'OpComercial';
    },

  },
  async created(){
    this.$store.dispatch("autoLogin")
  },
  methods:{
    salir(){
      this.$store.dispatch("salir");
    },
    name(){
      return this.$store.state.usuario.nombre;
    },
    async reporteventas(){
      this.totalprofit = 0;
      this.tprofit = 0;
      this.porsentajecumplido = 0;
      this.finicio = null;
      this.ffin = null;
      this.ntarget = 0;
      if(this.$store.state.usuario && this.$store.state.usuario.rol === 'Comercial' || this.$store.state.usuario && this.$store.state.usuario.rol === 'ComercialAdmin' || this.$store.state.usuario && this.$store.state.usuario.rol === 'PricingTerrestre' || 
         this.$store.state.usuario && this.$store.state.usuario.rol === 'PricingAgente' || this.$store.state.usuario && this.$store.state.usuario.rol === 'ComercialAgente' || this.$store.state.usuario && this.$store.state.usuario.rol === 'VentasFree'
         || this.$store.state.usuario && this.$store.state.usuario.rol === 'Pricing' || this.$store.state.usuario && this.$store.state.usuario.rol === 'OpComercial' )
         {
          let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
          let header={"Authorization" : "Bearer " + this.$store.state.token};
          let configuracion ={headers:header};
          var arrayTarget = [];
          await axios.get('api/targets/Select/' + me.$store.state.usuario.idusuario,configuracion).then(async function(response){
            arrayTarget=response.data;
            arrayTarget.map(function(x){
              me.ntarget = x.rate;
              me.finicio = x.vigenciainicio;
              me.ffin = x.vigenciafin;
            });
          }).catch(function(error){
            console.log(error);
          });
          if(me.finicio != null && me.ffin != null){
            await axios.get('api/Buysells/ReporteTarget/' + me.$store.state.usuario.idusuario + '/' + me.finicio + '/' + me.ffin,configuracion).then(async function(response){                
                me.BuySellLista = response.data;
                await me.total();
            }).catch(function(error){
                console.log(error);
            });
          }
        }
    },
    /*async oscar(){
      if(this.BuySellLista.length > 0){
          var i;
        for(i=0; i <= this.BuySellLista.length; i++){
          if(i != this.BuySellLista.length){
            if(this.BuySellLista[i].idbasis == 1 || this.BuySellLista[i].idbasis == 3){
                await this.CargarInformacion(this.BuySellLista[i].idoscar,this.BuySellLista[i].idbs,this.BuySellLista[i].idbasis);
            }else{
                await this.ListarChargeBS(this.BuySellLista[i].idbs);
            }
          }
        }
      }
    },
    async CargarInformacion(idoscar,idbs,idbasis){
        let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        var container = [];
        me.ncontainer = '';
        me.ntamaño = '';
          me.tarifasListar = [];
          me.infcontainers = [];
          if(idbasis == 1){
            await axios.get('api/Containers_pack_oscar_ogl/ListarContainersOscar/'+ idoscar,configuracion).then(async function(response){                
                container=response.data;
                var i = 0;
                var idsize = 0;
                  container.map(function (x){
                    if(idsize != x.idsize){
                        me.infcontainers.push({
                            number:container.length,
                            idsize:x.idsize,
                            idtype:x.idtype,
                            weight:'',
                        });
                        if(i == 0){
                            me.ncontainer = container.length;
                            me.ntamaño =   x.size + ' '+  x.type;
                        }else{
                            me.ncontainer = me.ncontainer + '/-/'+ container.length;
                            me.ntamaño =  me.ntamaño + '/-/' + x.size + ' '+  x.type;
                        }
                        i = i + 1;
                    }
                    idsize = x.idsize;
                });
                await me.ListarChargeBS(idbs);
            }).catch(function(error){
                console.log(error);
            }); 
          }else{
            await axios.get('api/InlandUnits/ListarContainers/'+ idoscar,configuracion).then(async function(response){
                container=response.data;
                var i = 0;
                var n = 0;
                var  size = 0;
                container.map(function(x){
                    n = n + 1;
                        if(size != x.idsize){
                            me.infcontainers.push({
                                idcontainer:x.idcontainer,
                                number:container.length,
                                idsize:x.idsize,
                                idtype:x.idtype,
                                weight:me.addCommas(x.grossweight),
                            });
                            size = x.idsize;
                        }
                        if(i == 0){
                            me.ncontainer = container.length;
                            me.ntamaño =   x.size + ' '+  x.type;
                        }else{
                            me.ncontainer = me.ncontainer + '/-/'+ container.length;
                            me.ntamaño =  me.ntamaño + '/-/' + x.size + ' '+  x.type;
                        }
                    i = i + 1;
                }); 
                await me.ListarChargeBS(idbs);
            }).catch(function(error){
                console.log(error);
            });
          }
            
    },
    async ListarChargeBS(idbs){
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        let me=this; 
        var buy=[];
        var sell=[]
        var i;
        var n;
        var tbuy = 0;
        var tsell = 0;
        var total = 0;
        var tbuyiva = 0;
        var tselliva = 0;
        me.totalsell = 0;
        me.totalbuy = 0;
        me.totalselliva = 0;
        me.totalbuyiva = 0;
        me.totalprofitiva = 0;
        me.totalbuybs = 0;
        me.totalsellbs = 0;
        me.tprofitbs = 0;
        var an=0;
        var ans=0;
        await axios.get('api/chargesBS/ListarChargesBuy/' + idbs,configuracion).then(async function(response){                            
            buy=response.data;
            buy.map(async function(x){
                var totalmxn = 0;
                if(x.cobrarenpesos == true){
                    totalmxn = me.addCommas(x.totalmxn);
                } 
                if(x.payment == 'container'){
                    for(i=0; i < me.infcontainers.length; i++){
                        an = an + 1;
                        if(x.idcontenedor == me.infcontainers[i].idtype && x.idtamano == me.infcontainers[i].idsize ){
                            for(n=0; n < me.infcontainers[i].number; n++){  
                                if(x.idcontenedor == me.infcontainers[i].idtype && x.idtamano == me.infcontainers[i].idsize ){
                                    tbuyiva = Number(tbuyiva) + Number(x.total);
                                    if(x.prepaid != 0){
                                        tbuy = Number(tbuy) + Number(x.prepaid);
                                    }
                                    if(x.collect != 0){
                                        tbuy = Number(tbuy) + Number(x.collect);
                                    }   
                                }
                            }
                        }
                    }
                }else{
                    if(x.payment == 'TON/m3'){
                        var costo;
                        var iva;   
                        var total;  
                        
                        if(me.pesovolumen >= me.actualw){
                            if(x.prepaid !=''){
                                costo = me.pesovolumen * x.prepaid;
                            }else{
                                costo = me.pesovolumen * x.collect;
                            }
                        }else{
                            if(x.prepaid !=''){
                                costo = me.actualw * x.prepaid;
                            }else{
                                costo = me.actualw * x.collect;
                            }
                        }
                        iva = Number(costo) * 0.16;
                        total = Number(costo) + Number(iva);
                        an = an + 1;
                    }else{
                        an = an + 1;
                    }
                    tbuyiva = Number(tbuyiva) + Number(x.total);
                    if(x.prepaid != 0){
                        tbuy = Number(tbuy) + Number(x.prepaid);
                    }
                    if(x.collect != 0){
                        tbuy = Number(tbuy) + Number(x.collect);
                    }
                }
            });
            me.totalbuyiva = parseFloat(Number(tbuyiva)).toFixed(2);
            me.totalbuy = parseFloat(Number(tbuy)).toFixed(2);
            me.totalbuybs = parseFloat(Number(tbuy)).toFixed(2);
            await axios.get('api/chargesBS/ListarChargesSell/' + idbs,configuracion).then(async function(response){
                sell=response.data;
                var fin = 0;
                await sell.map(async function(x){
                    var totalmxn = 0;
                    if(x.cobrarenpesos == true){
                        totalmxn = me.addCommas(x.totalmxn);
                    }
                    if(x.payment == 'container'){
                            for(i=0; i < me.infcontainers.length; i++){
                                if(x.idcontenedor == me.infcontainers[i].idtype && x.idtamano == me.infcontainers[i].idsize ){
                                    for(n = 0; n < me.infcontainers[i].number; n++){
                                        ans = ans + 1;
                                        tselliva = Number(tselliva) + Number(x.total);
                                        if(x.prepaid != 0){
                                            tsell = Number(tsell) + Number(x.prepaid);
                                        }
                                        if(x.collect != 0){
                                            tsell = Number(tsell) + Number(x.collect);
                                        }
                                    }
                                }
                            }
                    }else{
                        if(x.payment == 'TON/m3'){
                                var costo;
                                var iva;   
                                var total;  
                                
                                if(me.pesovolumen >= me.actualw){
                                    if(x.prepaid !=''){
                                        costo = me.pesovolumen * x.prepaid;
                                    }else{
                                        costo = me.pesovolumen * x.collect;
                                    }
                                }else{
                                    if(x.prepaid !=''){
                                        costo = me.actualw * x.prepaid;
                                    }else{
                                        costo = me.actualw * x.collect;
                                    }
                                }
                                iva = Number(costo) * 0.16;
                                total = Number(costo) + Number(iva);
                                an = an + 1;
                                tselliva = Number(tselliva) + Number(x.total);
                                if(x.prepaid != 0){
                                    tsell = Number(tsell) + Number(x.prepaid);
                                }
                                if(x.collect != 0){
                                    tsell = Number(tsell) + Number(x.collect);
                                }
                        }else{
                            ans = ans + 1;
                            tselliva = Number(tselliva) + Number(x.total);
                            if(x.prepaid != 0){
                                tsell = Number(tsell) + Number(x.prepaid);
                            }
                            if(x.collect != 0){
                                tsell = Number(tsell) + Number(x.collect);
                            }
                        }   
                    }
                    fin = fin + 1;
                });
                
                me.totalselliva = parseFloat(Number(tselliva)).toFixed(2);
                me.totalsell = parseFloat(Number(tsell)).toFixed(2);
                me.totalsellbs = parseFloat(Number(tsell)).toFixed(2);
                me.tprofit = Number(me.totalsellbs) - Number(me.totalbuybs);
                await me.total(); 
            }).catch(function(error){
                console.log(error);
            });
            }).catch(function(error){
                console.log(error);
            });
    },*/
    total(){  
      for(var i = 0; i < this.BuySellLista.length; i++){
        this.totalprofit = this.totalprofit + this.BuySellLista[i].profitt;
      }
    },
    PromedioVenta(){
      this.porsentajecumplido = (this.totalprofit / this.ntarget) * 100;
      if(this.porsentajecumplido <= 50 ){
        this.ncolor="rgb(255,17,0)";
      }
      if(this.porsentajecumplido > 50 && this.porsentajecumplido <= 75){
        this.ncolor="#2196f3";
      }
      if(this.porsentajecumplido > 75 ){
        this.ncolor="#4caf50";
      }
      return this.porsentajecumplido;
    },
    addCommas(nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    },
  }
};
</script>n

